/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon32Regular = forwardRef('ArrowShapeTriangleARightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 6.7c0-2.173 2.404-3.488 4.234-2.314l14.507 9.3c1.688 1.081 1.688 3.547 0 4.63l-14.507 9.299C9.404 28.788 7 27.474 7 25.3V6.7Zm3.155-.63A.75.75 0 0 0 9 6.7v18.6a.75.75 0 0 0 1.155.631l14.507-9.3a.75.75 0 0 0 0-1.262l-14.507-9.3Z" })));
});
